import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from '../../../../../contexts/AuthContext';
import { PermissionModulesEnum, PermissionActionsEnum } from '../../../../../enums';
import { hasResourseAccess } from '../../../../../utils/methods';

interface ReconciliationStatsProps {
  data: any;
}

const ReconciliationStats: React.FC<ReconciliationStatsProps> = ({ data }) => {
  const { t } = useTranslation();
  const { permissions, isSystemAdmin } = useContext(AuthContext);

  const canViewReconciliation = hasResourseAccess(isSystemAdmin, permissions, { accessibleTo: [{ [PermissionModulesEnum.Reconciliation]: [PermissionActionsEnum.View] }] });

  if (!canViewReconciliation) {
    return null;
  }

  return (
    <div className="row g-6 mb-6">
      <div className="col-sm-6 col-xl-6">
        <div className="card">
          <div className="card-body">
            <h5 className="mb-3 fw-bold">{t('layout.pageTexts.dashboard.pageTexts.reconciliation.title')}</h5>
            <div className="row">
              <div className="col-sm-4 col-xl-4 d-flex align-items-center">
                <div className="avatar">
                  <div className="avatar-initial bg-label-success rounded">
                    <i className="ri ri-check-double-line icon-24px"></i>
                  </div>
                </div>
                <div className="card-info ms-3">
                  <h5 className="mb-0">${data?.matched || '0.00'}</h5>
                  <p className="mb-0">{t('reconciliation.payout.list.pageTexts.table.kpis.matched')}</p>
                </div>
              </div>
              <div className="col-sm-4 col-xl-4 d-flex align-items-center">
                <div className="avatar">
                  <div className="avatar-initial bg-label-danger rounded">
                    <i className="ri ri-error-warning-line icon-24px"></i>
                  </div>
                </div>
                <div className="card-info ms-3">
                  <h5 className="mb-0">${data?.unmatched || '0.00'}</h5>
                  <p className="mb-0">{t('reconciliation.payout.list.pageTexts.table.kpis.unmatched')}</p>
                </div>
              </div>
              <div className="col-sm-4 col-xl-4 d-flex align-items-center">
                <div className="avatar">
                  <div className="avatar-initial bg-label-info rounded">
                    <i className="ri ri-percent-line icon-24px"></i>
                  </div>
                </div>
                <div className="card-info ms-3">
                  <h5 className="mb-0">{data?.ratio || '0'}%</h5>
                  <p className="mb-0">{t('reconciliation.payout.list.pageTexts.table.kpis.ratio')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReconciliationStats;
